import { createPaymentTokenAction, postStripeChargesAction } from './action'
import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from "next-redux-wrapper";

const initialState: PaymentProcess.PaymentProcess = {
  action: null,
  paymentToken: {
    status: 'none',
    data: {} as Record<string, unknown>
  },
  paymentCharges: {
    status: 'none',
    data: {} as Record<string, unknown>
  }
}

export const paymentProcessSlice = createSlice({
  name: '@paymentProcess',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentTokenAction.pending, (state) => {
        state.action = 'createPaymentTokenAction.pending'
        state.paymentToken.status = 'pending'
      })
      .addCase(createPaymentTokenAction.fulfilled, (state) => {
        state.action = 'createPaymentTokenAction.fulfilled'
        state.paymentToken.status = 'fulfilled'
      })
      .addCase(createPaymentTokenAction.rejected, (state, action) => {
        state.action = 'createPaymentTokenAction.rejected'
        state.paymentToken.status = 'rejected'
        state.paymentToken.error = action.error.message
      })
      .addCase(postStripeChargesAction.pending, (state) => {
        state.action = 'postStripeChargesAction.pending'
        state.paymentCharges.status = 'pending'
      })
      .addCase(postStripeChargesAction.fulfilled, (state, action) => {
        state.action = 'postStripeChargesAction.fulfilled'
        state.paymentCharges.status = 'fulfilled'
        state.paymentCharges.data = action.payload.payload
      })
      .addCase(postStripeChargesAction.rejected, (state, action) => {
        state.action = 'postStripeChargesAction.rejected'
        state.paymentCharges.status = 'rejected'
        state.paymentCharges.error = action.error.message
      })
      .addCase(HYDRATE, (state, action) => ({
        ...state,
        ...action['payload']['@paymentProcess'],
      }))
  }
})
